<template>
  <span>{{ formatedDate }}</span>
</template>

<script>
    export default {
        name: "DateFormatter",
        props: ['unixTime'],
        computed: {
          formatedDate() {
              return this.formatDate(this.unixTime);
          }
        },
        methods: {
            formatDate(data) {
                let date = new Date(Number(data));
                let mm = date.getMonth() + 1;
                let dd = date.getDate();

                return [
                    date.getFullYear(),
                    (mm>9 ? '' : '0') + mm,
                    (dd>9 ? '' : '0') + dd,
                ].join('/');
            }
        }
    }
</script>

<style scoped>

</style>
